<template>
  <Autocomplete
    :placeholder="$t('placeholder.sport_type_or_club')"
    :items="items"
    :input-value="search"
    :is-clearable="true"
    :handler-function="querySelections"
    @emitSelection="saveSelection"
  />
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import SetSportTypeClub from '@/dependencies/mixins/set-sport-type-club'
import WatchSportTypeClub from '@/dependencies/mixins/watch-sport-type-club'
import Autocomplete from '~/components/Common/AutocompleteHighlight'

export default {
  name: 'SportTypeClub',
  components: {
    Autocomplete
  },
  mixins: [SetSportTypeClub, WatchSportTypeClub],
  data() {
    return {
      items: [],
      search: '',
      chosenItem: ''
    }
  },
  computed: {
    ...mapGetters({
      sportType: 'search/searchSportType',
      sportClub: 'search/searchSportClub',
      searchLocation: 'search/searchLocation'
    })
  },
  methods: {
    ...mapActions({
      setSportClub: 'search/SET_SPORT_CLUB'
    }),
    //  this function is transmitted to Autocomplete
    async querySelections(v, highlight) {
      if (v.length >= 3) {
        try {
          const sportsClubsList = await this.$api.SportApi.getSportsClubsList({
            params: {
              title: v,
              city_id: this.searchLocation
            }
          })
          this.items = []
          for (const i in sportsClubsList.data.data) {
            const item = sportsClubsList.data.data[i]
            this.items.push(highlight(item, v))
          }
        } catch (e) {
          // eslint-disable-next-line no-console
          console.log(e)
        }
      } else {
        this.items = []
      }
    },
    saveSelection(item) {
      this.setSportClub(item)
      this.chosenItem = item

      item && this.handleSelection()

      //  necessary in case no filters is chosen besides sport or club
      this.$bus.$emit('clearList', true)
    }
  }
}
</script>

<style scoped></style>
